import React from "react";
import { Rating } from "@material-tailwind/react";

function LeaderProfileReviews({
  showReviews,
  handleToggleReviews,
  reversedReviews,
  t
}) {
  return (
    <div className="2xl:col-span-2 flex flex-col gap-4 2xl:gap-12 mt-16 justify-center items-center">
      <div
        onClick={handleToggleReviews}
        className="cursor-pointer text-xl underline font-bold"
      >
        {showReviews
          ? t("leader_profile.hide_review")
          : t("leader_profile.recent_review")}
      </div>
      {showReviews && (
        <div className="2xl:col-span-2 flex flex-col gap-4 2xl:gap-12 mt-0 justify-center items-center">
          <div className="flex flex-col gap-3">
            {reversedReviews.slice(0, 10).map((review, index) => {
              return (
                <div key={index} className="flex flex-col md:flex-row">
                  <div className="flex justify-center items-center">
                    <p className="text-xl font-bold">
                      {t("leader_profile.review_from")}
                    </p>
                    <p className="ml-2 mr-8 text-xl">
                      {review.meeting_id?.follower?.first_name +
                        " " +
                        review.meeting_id?.follower?.last_name}
                    </p>
                    <Rating value={review?.stars} readonly />
                  </div>
                  <div className="flex flex-col mt-2 md:mt-0 md:flex-row items-center justify-center">
                    <p className="text-xl font-bold md:ml-8">
                      {t("leader_profile.review_to")}
                    </p>
                    <p className="md:ml-2 text-xl">{review?.comment}</p>
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}

export default LeaderProfileReviews;
